import React, { useState } from "react";
import { Col } from "reactstrap";

//Date Picker

// import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
import { StandardPickerDateFormat } from "common/utility";
import DateRangePicker from "react-bootstrap-daterangepicker";

// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
import schedule from "../../assets/images/schedule.svg";
import calendarremovelines from "../../assets/images/calanderremoveLines.svg";
const DateRangeFilter = ({
  dateFilterChange,
  setCalendarIsShowing,
  inputRef,
  dateFilter,
  setDateFilter,
  calendarIsShowing,
  handleFilterChange,
}) => {
  const handleCallback = (start, end, label) => {
    console.log(start, end, label);
  };
  return (
    <React.Fragment>
      <div>
        <div className="position-relative">
          <DateRangePicker
            initialSettings={{
              autoUpdateInput: false,
              locale: {
                cancelLabel: "Clear",
              },
            }}
            onApply={dateFilterChange}
            onShow={() => setCalendarIsShowing(true)}
            onHide={() => setCalendarIsShowing(false)}
            onCallback={handleCallback}
          >
            <input
              ref={inputRef}
              placeholder="Filter by Date"
              readOnly={true}
              className="form-control"
              value={
                dateFilter.length
                  ? `${StandardPickerDateFormat(
                      dateFilter[0]
                    )} - ${StandardPickerDateFormat(dateFilter[1])}`
                  : ""
              }
            />
          </DateRangePicker>
          <img
            onClick={() => {
              if (!calendarIsShowing && dateFilter.length) {
                setDateFilter([]);
                handleFilterChange();
              }
            }}
            src={
              calendarIsShowing
                ? calendarremovelines
                : dateFilter.length
                ? calendarremovelines
                : schedule
            }
            alt="dateFilter"
            width={20}
            role="button"
            className="position-absolute top-50 end-0 translate-middle-y me-2"
          />
        </div>
      </div>
    </React.Fragment>
  );
};
export default DateRangeFilter;
